export default "__VITE_ASSET__DipFYfdM__"